import { payloadFromToken } from '../api/auth';

export default function useIsAdmin() {
  try {
    const token = window.localStorage.getItem('id_token');
    if (!token) return false;
    const payload = payloadFromToken(token);
    const groups = payload['cognito:groups'];
    const checkGroup = (group) => group === 'Admin' || group === 'Admins';
    if (Array.isArray(groups)) return groups.some(checkGroup);
    return checkGroup(groups);
  } catch (e) {
    return false;
  }
}
